define([
    "./regionModule",
    "./regionImportModal",
    "./regionServiceUrls"
], function () {
});